export default "<div class=\"jr-mOverlay jr-isHidden jr\">\n\n    <js-templateNonce></js-templateNonce>\n</div>\n";